import React, { useEffect, useState } from "react";
import { useParams, useRouteMatch, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Hidden,
  useTheme,
  Breadcrumbs,
  Button,
  makeStyles,
  createStyles,
  Grid,
  fade,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from "@material-ui/core";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import HomeIcon from "@material-ui/icons/Home";
import { useForm } from "react-hook-form";
import {
  ERROR_MESSAGE_UNEXPECTED_ERROR,
  SUCCESSFULLY_CREATED,
  SUCCESSFULLY_UPDATED,
} from "../../../../../utils/consts";
import {
  fetchGlobalDepartmentInfo,
  fetchProductConfigInfo,
} from "../../../../../services/menuApp/printerMenuService";
import PageHeaderMobile from "../../../../../components/common/PageHeader/PageHeaderMobile";
import DefaultAlert from "../../../../../components/alerts/DefaultAlert";
import ButtonCommon from "../../../../../components/buttons/ButtonCommon";
import withAuthority from "../../../../../components/Auth/withAuthority";
import Authorities from "../../../../../auth/authorities";
import {
  fetchAllMenuDetails,
  fetchMenus,
  setProductsVersion,
  fetchMenuDetails,
} from "../../../../../redux/actions/menu";
import { updateDirectoryInStore } from "../../../../../redux/actions/menu";
import { DeliveryTpe } from "../../../../../utils/enum";
import { fetchTags } from "../../../../../services/menuApp/categoryMenuService";
// Import refactored components
import ProductBanner from "./components/ProductBanner";
import OverviewSection from "./components/OverviewSection";
import AvailabilitySection from "./components/AvailabilitySection";
import SystemInformationSection from "./components/SystemInformationSection";
import ActionButtons from "./components/ActionButtons";
// Import hooks and utils
import { useProductData } from "./hooks/useProductData";
import { useProductForm } from "./hooks/useProductForm";
import { useChangeTracking } from "./hooks/useChangeTracking";
import ProductsSection from "./components/ProductsSection";
import { copyToClipboard } from "./types/ProductUtils";
import TagsSpotlightSection from "./components/TagsSpotlightSection";
import { CustomTheme } from "../../../../../types/customTheme";
import {
  updateProductInfo,
  updateWrapperInfo,
} from "../../../../../services/menuApp/menuService";
import { AxiosError } from "axios";
import AvailabilitySections from "./components/AvailabilitySections";
import {
  fetchMenuOption,
  updateMenuOptionInfo,
} from "../../../../../services/menuApp/categoryMenuService";
import ProductSkeletonLoading from "./ProductSkeletonLoading";
const useStyles = makeStyles((theme: any) =>
  createStyles({
    autoComplete: {
      marginTop: "4px",
      "& .MuiAutocomplete-input": {
        color: theme.palette.custom.orange.contrastText,
      },
      "& .MuiInputBase-root": {
        color: "inherit",
        backgroundColor: theme.palette.background.entity_background,
        borderRadius: 10,
      },
      [`& fieldset`]: {
        borderRadius: 10,
        border: `1px solid ${theme.palette.background.entity_border}`,
        color: theme.palette.custom.orange.contrastText,
      },
    },
    titleColor: {
      color: theme.palette.custom.orange.contrastText,
    },
    textField: {
      overflowWrap: "break-word",
      wordWrap: "break-word",
      borderRadius: "10px",
      backgroundColor: "transparent",
      [`& fieldset`]: {
        borderRadius: "10px",
        border: `1px solid ${theme.palette.background.entity_border}`,
        cursor: "pointer",
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        border: `1px solid ${theme.palette.background.entity_border}`,
      },
      "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: `1px solid ${theme.palette.background.entity_border}`,
      },
    },
    tagChip: {
      backgroundColor: theme.palette.custom.blue.main,
      color: theme.palette.custom.blue.contrastText,
      fontWeight: 500,
      fontSize: "9px",
      height: "24px", // Increased height
      padding: "2px 8px", // ✅ Padding inside chip
      borderRadius: "12px",
      "& .MuiChip-label": {
        padding: "0 8px", // ✅ Label padding
        fontSize: "10px",
        lineHeight: "20px",
      },
      "& .MuiChip-deleteIcon": {
        fontSize: "12px !important",
        margin: "0 4px 0 -4px",
        width: "14px",
        height: "14px",
        color: theme.palette.custom.blue.contrastText,
        "&:hover": {
          color: theme.palette.custom.blue.main,
        },
      },
    },
  }),
);
interface Params {
  menuId: string;
  productId: string;
  locationId: string;
  "0"?: string;
}
interface MenuProductProps {
  onProductUpdated?: () => void;
}
export const platformSelectorObj: any = {
  "walk in": { id: "walk in", label: "Walk In" },
  phone: { id: "phone", label: "Phone" },
  kiosk: { id: "kiosk", label: "Kiosk" },
  online: { id: "online", label: "Online" },
};
export const channelSelectorList = [
  { id: "eatpresto", label: "Eat Presto" },
  { id: "deliverect", label: "Deliverect" },
  { id: "justeat", label: "Just Eat" },
  { id: "deliveroo", label: "Deliveroo" },
  { id: "ubereats", label: "Uber Eats" },
];
const MenuProduct: React.FC<MenuProductProps> = ({ onProductUpdated }) => {
  const params = useParams<Params>();
  const match: any = useRouteMatch();
  const history = useHistory();
  const theme = useTheme();
  const dispatch = useDispatch();
  const classes = useStyles();
  const { menuId, productId, locationId } = params;
  // Redux state
  const { menuDetails, menus } = useSelector((state: any) => {
    console.log("asdasd", state);
    return state.menu;
  });
  const currentMenuData = menuDetails[menuId];
  // Local state
  const [isLoadingButton, setIsLoadingButton] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [stockDepartmentSelectedNode, setStockDepartmentSelectedNode] =
    useState<any[]>([]);
  const [itemTypesList] = useState([{ id: "1", label: "1111" }]);
  const [expandedProductIds, setExpandedProductIds] = useState<
    Set<string | number>
  >(new Set());
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const productsVersion = useSelector(
    (state: any) => state.menu?.productsVersion || 1,
  );
  const isEditDisabled = productsVersion === 1;
  // Delivery Types State
  const [deliveryTypesListInitial, setDeliveryTypesListInitial] = useState<any>(
    [],
  );
  const [deliveryTypesList, setDeliveryTypesList] = useState<any>([]);
  // Platform State
  const [platformListInitial, setPlatformListInitial] = useState<any>([]);
  const [platformList, setPlatformList] = useState<any>([]);
  // Channel State
  const [channelListInitial, setChannelListInitial] = useState<any>([]);
  const [channelList, setChannelList] = useState<any>([]);
  // Availability State
  const [availabilityList, setAvailabilityList] = useState<any>([]);
  const [availabilityListInitial, setAvailabilityListInitial] = useState<any>(
    [],
  );
  const [availabilityErrorMessage, setAvailabilityErrorMessage] = useState("");
  // State for time and week values
  const [weekFrom, setWeekFrom] = useState<number>(1);
  const [weekTo, setWeekTo] = useState<number>(7);
  const [timeFrom, setTimeFrom] = useState<number>(0);
  const [timeTo, setTimeTo] = useState<number>(23);
  const [hasTimeWeekChanges, setHasTimeWeekChanges] = useState(false);
  const [menuOptionNodeObj, setMenuOptionNodeObj] = useState<any>([]);
  const [menuOptionData, setMenuOptionData] = useState<any>(null);
  const [isMenuOptionLoading, setIsMenuOptionLoading] = useState(true);
  const [isProductAddModalOpen, setIsProductAddModalOpen] = useState(false);
  // ✅ True the instant the "Add Product" modal closes after a successful
  // add, until the menu/product data refresh finishes — used to show the
  // loading skeleton immediately instead of waiting for refreshProductData()
  // to flip its own internal loading state.
  const [isRefreshingAfterAdd, setIsRefreshingAfterAdd] = useState(false);
  // ✅ State for tags from API
  const [availableTags, setAvailableTags] = useState<any[]>([]);
  // Active State
  const [originalNodeData, setOriginalNodeData] = useState<any>({
    entityId: "",
    isActive: false,
    availability: [],
    deliveryTypes: [],
  });
  const [isActiveInitial, setIsActiveInitial] = useState(true);
  const [isActive, setIsActive] = useState(true);
  // ✅ Dialog state for unsaved changes
  const [isLeaveDialogOpen, setIsLeaveDialogOpen] = useState(false);
  const [pendingNavigation, setPendingNavigation] = useState<string | null>(
    null,
  );
  // Custom hooks
  const {
    isValidMainProduct,
    setIsValidMainProduct,
    isValidProduct,
    setIsValidProduct,
    isValidProductAvailability,
    setIsValidProductAvailability,
    isValidKiosk,
    setIsValidKiosk,
    color,
    setColor,
    allYouCanEat,
    setAllYouCanEat,
    isByo,
    setIsByo,
    isCustomisationPriority,
    setIsCustomisationPriority,
    isSpicySelectionEnabled,
    setIsSpicySelectionEnabled,
    inTax,
    setInTax,
    outTax,
    setOutTax,
    selectedTags,
    setSelectedTags,
    spotlightText,
    setSpotlightText,
    selectedItemType,
    setSelectedItemType,
    open,
    setOpen,
    register,
    handleSubmit,
    errors,
    reset,
  } = useProductForm();
  // Custom data hook
  const {
    isLoading,
    productData,
    wrapperData,
    selectedProduct,
    selectedMenuName,
    categoryName,
    categoryId,
    directoryStack,
    selectedDepartmentObj,
    setSelectedDepartmentObj,
    setProductData,
    setWrapperData,
    setSelectedProduct,
    refreshProductData,
  } = useProductData(
    locationId,
    menuId,
    productId,
    stockDepartmentSelectedNode,
    menus,
    currentMenuData,
    reset,
  );
  // Get all platform IDs
  const allPlatformIds = Object.values(platformSelectorObj).map(
    (p: any) => p.id,
  );
  // Get all channel IDs
  const allChannelIds = channelSelectorList.map((c) => c.id);
  // Get all delivery type IDs
  const allDeliveryTypes = [
    DeliveryTpe.DINEIN,
    DeliveryTpe.DELIVERY,
    DeliveryTpe.TAKEOUT,
  ];
  // ✅ Fetch tags when component mounts
  useEffect(() => {
    const loadTags = async () => {
      try {
        const res = await fetchTags(locationId);
        console.log("Fetched tags from API:", res?.data?.data);
        if (res?.data?.data) {
          const tagsArray = Object.values(res.data.data);
          setAvailableTags(tagsArray);
          console.log("Tags set to state:", tagsArray);
        }
      } catch (error) {
        console.error("Error fetching tags:", error);
      }
    };
    loadTags();
  }, [locationId]);
  // Initialize states from loaded data
  useEffect(() => {
    if (wrapperData) {
      setIsValidMainProduct(
        wrapperData.valid !== undefined ? wrapperData.valid : true,
      );
      setIsValidKiosk(wrapperData.kiosk?.toString() === "1");
      setColor(wrapperData.colour || "");
      setAllYouCanEat(wrapperData.allYouCanEat || false);
      setIsValidProductAvailability(
        wrapperData.valid !== undefined ? wrapperData.valid : true,
      );
      if (wrapperData.weekFrom !== undefined && wrapperData.weekFrom !== null) {
        setWeekFrom(wrapperData.weekFrom);
      }
      if (wrapperData.weekTo !== undefined && wrapperData.weekTo !== null) {
        setWeekTo(wrapperData.weekTo);
      }
      if (wrapperData.timeFrom !== undefined && wrapperData.timeFrom !== null) {
        setTimeFrom(wrapperData.timeFrom);
      }
      if (wrapperData.timeTo !== undefined && wrapperData.timeTo !== null) {
        setTimeTo(wrapperData.timeTo);
      }
      if (wrapperData.itemType && itemTypesList.length > 0) {
        const foundItemType = itemTypesList.find(
          (item: any) =>
            item.id === wrapperData.itemType ||
            item.label === wrapperData.itemType,
        );
        if (foundItemType) {
          setSelectedItemType(foundItemType);
        }
      }
      if (wrapperData.spotlight !== undefined) {
        setSpotlightText(wrapperData.spotlight || "");
      }
    }
    if (productData) {
      setIsByo(productData.isByo || false);
      setIsCustomisationPriority(productData.isCustomisationPriority || false);
      setIsSpicySelectionEnabled(productData.isSpicySelectionEnabled || false);
      setIsValidProduct(
        productData.valid !== undefined ? productData.valid : true,
      );
      if (productData.inTax !== undefined) {
        setInTax({ id: productData.inTax, name: `${productData.inTax}%` });
      }
      if (productData.outTax !== undefined) {
        setOutTax({ id: productData.outTax, name: `${productData.outTax}%` });
      }
    }
  }, [wrapperData, productData]);
  useEffect(() => {
    getMenuOptionInfo();
  }, []);
  const handleNavigateToCategory = () => {
    if (categoryId) {
      history.push(`/${locationId}/presto-menus/menus/${menuId}`);
    }
  };
  const {
    hasWrapperChanges,
    hasProductChanges,
    trackWrapperChange,
    trackProductChange,
    resetChanges,
    getChangedWrapperData,
    getChangedProductData,
    getAllChangedProducts,
  } = useChangeTracking(wrapperData, selectedProduct);
  const toggleProductExpand = (productId: string | number) => {
    setExpandedProductIds((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(productId)) {
        newSet.delete(productId);
      } else {
        newSet.add(productId);
      }
      return newSet;
    });
  };
  const getProductConfiguration = async () => {
    if (!locationId) return;
    try {
      const { data } = await fetchProductConfigInfo(locationId);
      if (data && data.data) {
        const version = data.data.productsVersion || 1;
        dispatch(setProductsVersion(version));
      }
    } catch (error) {
      const err: any = error as AxiosError;
      if (err.response?.status !== 404) {
        console.error("Error fetching product configuration:", error);
      }
    }
  };
  useEffect(() => {
    console.log("wrapperData updated:", wrapperData);
    console.log("productData updated:", productData);
  }, [wrapperData, productData]);
  // Initial load
  useEffect(() => {
    const loadAllData = async () => {
      if (isInitialLoad && (!menus || menus.length === 0)) {
        console.log("Initial load - fetching all menus and details");
        setIsMenuOptionLoading(false);
        await dispatch(fetchMenus(match.params.locationId));
        await dispatch(fetchAllMenuDetails(match.params.locationId));
        await getProductConfiguration();
        setIsInitialLoad(false);
      }
    };
    loadAllData();
  }, [dispatch, match.params.locationId, menus, isInitialLoad, isEditDisabled]);
  const getMenuOptionInfo = async () => {
    try {
      const res = await fetchMenuOption(match.params.locationId);
      const menuOptionNode = res.data.data;
      setMenuOptionData(menuOptionNode);
      const menuOptionList = menuOptionNode?.options?.[`M${productId}`] || {};
      setMenuOptionNodeObj(menuOptionList);
      setIsMenuOptionLoading(false);
    } catch (err) {
      setError(ERROR_MESSAGE_UNEXPECTED_ERROR);
    }
  };
  // Fetch departments and config
  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const res = await fetchGlobalDepartmentInfo(locationId);
        if (res?.data?.data) {
          setStockDepartmentSelectedNode(res.data.data);
        }
      } catch (err) {
        setError(ERROR_MESSAGE_UNEXPECTED_ERROR);
      }
    };
    const fetchConfig = async () => {
      try {
        await fetchProductConfigInfo(locationId);
      } catch (err) {
        setError(ERROR_MESSAGE_UNEXPECTED_ERROR);
      }
    };
    fetchDepartments();
    fetchConfig();
  }, [locationId]);
  // ✅ Updated Navigation handlers with unsaved changes check
  const handleBackToDirectory = () => {
    // Check if there are unsaved changes
    if (hasWrapperChanges || hasProductChanges || hasTimeWeekChanges) {
      // Show custom dialog
      setIsLeaveDialogOpen(true);
      const directoryPath = `${match.url.split("/product")[0]}`;
      setPendingNavigation(directoryPath);
      return;
    }
    // No unsaved changes, navigate back directly
    const directoryPath = `${match.url.split("/product")[0]}`;
    history.push(directoryPath);
  };
  const handleConfirmLeave = () => {
    // Reset changes and navigate
    resetChanges();
    setIsLeaveDialogOpen(false);
    if (pendingNavigation) {
      history.push(pendingNavigation);
      setPendingNavigation(null);
    }
  };
  const handleCancelLeave = () => {
    setIsLeaveDialogOpen(false);
    setPendingNavigation(null);
  };
  const handleNavigateToMenu = () => {
    // Check if there are unsaved changes
    if (hasWrapperChanges || hasProductChanges || hasTimeWeekChanges) {
      setIsLeaveDialogOpen(true);
      setPendingNavigation(`/${locationId}/presto-menus/menus`);
      return;
    }
    history.push(`/${locationId}/presto-menus/menus`);
  };
  const handleNavigateToDirectory = (index: number) => {
    // Check if there are unsaved changes
    if (hasWrapperChanges || hasProductChanges || hasTimeWeekChanges) {
      let path = `/${locationId}/presto-menus/menus/${menuId}`;
      for (let i = 0; i <= index; i++) {
        path += `/directory/${directoryStack[i].id}`;
      }
      setIsLeaveDialogOpen(true);
      setPendingNavigation(path);
      return;
    }
    let path = `/${locationId}/presto-menus/menus/${menuId}`;
    for (let i = 0; i <= index; i++) {
      path += `/directory/${directoryStack[i].id}`;
    }
    history.push(path);
  };
  const handleWeekFromChange = (value: number) => {
    setWeekFrom(value);
    setHasTimeWeekChanges(true);
    trackWrapperChange("weekFrom", value);
  };
  const handleWeekToChange = (value: number) => {
    setWeekTo(value);
    setHasTimeWeekChanges(true);
    trackWrapperChange("weekTo", value);
  };
  const handleTimeFromChange = (value: number) => {
    setTimeFrom(value);
    setHasTimeWeekChanges(true);
    trackWrapperChange("timeFrom", value);
  };
  const handleTimeToChange = (value: number) => {
    setTimeTo(value);
    setHasTimeWeekChanges(true);
    trackWrapperChange("timeTo", value);
  };
  const saveProductWrapperChanges = async (
    changedWrapperData: any,
    logBody: any,
    logAppName: any,
  ) => {
    const wrapperBody = {
      id: wrapperData?.id,
      locationId: locationId,
      version: wrapperData?.version,
      ...changedWrapperData,
    };
    const response = await updateWrapperInfo(
      locationId,
      wrapperBody,
      "Menus Changed",
      logBody,
      logAppName,
    );
    return response;
  };
  const handleImmediateWrapperValidToggle = async (checked: boolean) => {
    setIsValidMainProduct(checked);
    if (!wrapperData) return;
    setIsLoadingButton(true);
    try {
      const changedData = { valid: checked };
      const wrapperBody = {
        id: wrapperData?.id,
        locationId: locationId,
        version: wrapperData?.version,
        ...changedData,
      };
      const response = await updateWrapperInfo(
        locationId,
        wrapperBody,
        "Menus Changed",
        `Product wrapper valid status changed to ${checked}`,
        "menu",
      );
      if (response?.data?.data) {
        const updatedWrapper = response.data.data;
        setWrapperData(updatedWrapper);
        dispatch(
          updateDirectoryInStore({
            id: updatedWrapper.id,
            valid: updatedWrapper.valid,
            version: updatedWrapper.version,
            name: updatedWrapper.name,
            colour: updatedWrapper.colour,
            img: updatedWrapper.img,
            desc: updatedWrapper.desc,
            directory: updatedWrapper.directory,
            directoryId: updatedWrapper.directoryId,
            directoryLevel: updatedWrapper.directoryLevel,
            itemType: updatedWrapper.itemType,
            allYouCanEat: updatedWrapper.allYouCanEat,
            kiosk: updatedWrapper.kiosk,
            cover: updatedWrapper.cover,
            nameShort: updatedWrapper.nameShort,
            viewOrder: updatedWrapper.viewOrder,
          }),
        );
        await dispatch(fetchMenuDetails(locationId, menuId));
        setSuccess(
          `Product ${checked ? "activated" : "deactivated"} successfully`,
        );
        setTimeout(() => setSuccess(""), 2000);
        if (onProductUpdated) {
          onProductUpdated();
        }
      }
    } catch (err) {
      console.error("Error updating wrapper valid status:", err);
      setError(ERROR_MESSAGE_UNEXPECTED_ERROR);
      setIsValidMainProduct(!checked);
    } finally {
      setIsLoadingButton(false);
    }
  };
  const handleImmediateProductValidToggle = async (
    productId: string,
    checked: boolean,
    product: any,
  ) => {
    if (!product) return;
    setIsLoadingButton(true);
    try {
      const productBody = {
        id: product.id,
        locationId: locationId,
        version: product.version,
        valid: checked,
      };
      const response = await updateProductInfo(
        locationId,
        productBody,
        "Menus Changed",
        `Product ${product.name} valid status changed to ${checked}`,
        "menu",
      );
      if (response?.data?.data) {
        const updatedProduct = response.data.data;
        setSelectedProduct((prev) =>
          prev.map((p) =>
            p.id === productId
              ? { ...p, ...updatedProduct, valid: checked }
              : p,
          ),
        );
        setSuccess(
          `Product ${checked ? "activated" : "deactivated"} successfully`,
        );
        setTimeout(() => setSuccess(""), 2000);
      }
    } catch (err) {
      console.error("Error updating product valid status:", err);
      setError(ERROR_MESSAGE_UNEXPECTED_ERROR);
    } finally {
      setIsLoadingButton(false);
    }
  };
  const handleImmediateAvailabilityToggle = async (checked: boolean) => {
    setIsValidProductAvailability(checked);
    if (!wrapperData) return;
    setIsLoadingButton(true);
    try {
      const changedData = { valid: checked };
      const wrapperBody = {
        id: wrapperData?.id,
        locationId: locationId,
        version: wrapperData?.version,
        ...changedData,
      };
      const response = await updateWrapperInfo(
        locationId,
        wrapperBody,
        "Menus Changed",
        `Product wrapper availability changed to ${checked}`,
        "menu",
      );
      if (response?.data?.data) {
        const updatedWrapper = response.data.data;
        setWrapperData(updatedWrapper);
        dispatch(
          updateDirectoryInStore({
            id: updatedWrapper.id,
            valid: updatedWrapper.valid,
            version: updatedWrapper.version,
            name: updatedWrapper.name,
            colour: updatedWrapper.colour,
            img: updatedWrapper.img,
            desc: updatedWrapper.desc,
            directory: updatedWrapper.directory,
            directoryId: updatedWrapper.directoryId,
            directoryLevel: updatedWrapper.directoryLevel,
            itemType: updatedWrapper.itemType,
            allYouCanEat: updatedWrapper.allYouCanEat,
            kiosk: updatedWrapper.kiosk,
            cover: updatedWrapper.cover,
            nameShort: updatedWrapper.nameShort,
            viewOrder: updatedWrapper.viewOrder,
          }),
        );
        await dispatch(fetchMenuDetails(locationId, menuId));
        setSuccess(
          `Availability ${checked ? "enabled" : "disabled"} successfully`,
        );
        setTimeout(() => setSuccess(""), 2000);
      }
    } catch (err) {
      console.error("Error updating availability:", err);
      setError(ERROR_MESSAGE_UNEXPECTED_ERROR);
      setIsValidProductAvailability(!checked);
    } finally {
      setIsLoadingButton(false);
    }
  };
  const handleImmediateAllYouCanEatToggle = async (checked: boolean) => {
    setAllYouCanEat(checked);
    if (!wrapperData) return;
    setIsLoadingButton(true);
    try {
      const changedData = { allYouCanEat: checked };
      const wrapperBody = {
        id: wrapperData?.id,
        locationId: locationId,
        version: wrapperData?.version,
        ...changedData,
      };
      const response = await updateWrapperInfo(
        locationId,
        wrapperBody,
        "Menus Changed",
        `All You Can Eat setting changed to ${checked}`,
        "menu",
      );
      if (response?.data?.data) {
        const updatedWrapper = response.data.data;
        setWrapperData(updatedWrapper);
        dispatch(
          updateDirectoryInStore({
            id: updatedWrapper.id,
            valid: updatedWrapper.valid,
            version: updatedWrapper.version,
            name: updatedWrapper.name,
            colour: updatedWrapper.colour,
            img: updatedWrapper.img,
            desc: updatedWrapper.desc,
            directory: updatedWrapper.directory,
            directoryId: updatedWrapper.directoryId,
            directoryLevel: updatedWrapper.directoryLevel,
            itemType: updatedWrapper.itemType,
            allYouCanEat: updatedWrapper.allYouCanEat,
            kiosk: updatedWrapper.kiosk,
            cover: updatedWrapper.cover,
            nameShort: updatedWrapper.nameShort,
            viewOrder: updatedWrapper.viewOrder,
          }),
        );
        await dispatch(fetchMenuDetails(locationId, menuId));
        setSuccess(
          `All You Can Eat ${checked ? "enabled" : "disabled"} successfully`,
        );
        setTimeout(() => setSuccess(""), 2000);
      }
    } catch (err) {
      console.error("Error updating All You Can Eat:", err);
      setError(ERROR_MESSAGE_UNEXPECTED_ERROR);
      setAllYouCanEat(!checked);
    } finally {
      setIsLoadingButton(false);
    }
  };
  const handleImmediateKioskToggle = async (checked: boolean) => {
    setIsValidKiosk(checked);
    if (!wrapperData) return;
    setIsLoadingButton(true);
    try {
      const changedData = { kiosk: checked ? "1" : "0" };
      const wrapperBody = {
        id: wrapperData?.id,
        locationId: locationId,
        version: wrapperData?.version,
        ...changedData,
      };
      const response = await updateWrapperInfo(
        locationId,
        wrapperBody,
        "Menus Changed",
        `Kiosk setting changed to ${checked}`,
        "menu",
      );
      if (response?.data?.data) {
        const updatedWrapper = response.data.data;
        setWrapperData(updatedWrapper);
        dispatch(
          updateDirectoryInStore({
            id: updatedWrapper.id,
            valid: updatedWrapper.valid,
            version: updatedWrapper.version,
            name: updatedWrapper.name,
            colour: updatedWrapper.colour,
            img: updatedWrapper.img,
            desc: updatedWrapper.desc,
            directory: updatedWrapper.directory,
            directoryId: updatedWrapper.directoryId,
            directoryLevel: updatedWrapper.directoryLevel,
            itemType: updatedWrapper.itemType,
            allYouCanEat: updatedWrapper.allYouCanEat,
            kiosk: updatedWrapper.kiosk,
            cover: updatedWrapper.cover,
            nameShort: updatedWrapper.nameShort,
            viewOrder: updatedWrapper.viewOrder,
          }),
        );
        await dispatch(fetchMenuDetails(locationId, menuId));
        setSuccess(`Kiosk ${checked ? "enabled" : "disabled"} successfully`);
        setTimeout(() => setSuccess(""), 2000);
      }
    } catch (err) {
      console.error("Error updating Kiosk setting:", err);
      setError(ERROR_MESSAGE_UNEXPECTED_ERROR);
      setIsValidKiosk(!checked);
    } finally {
      setIsLoadingButton(false);
    }
  };
  // ✅ handleSaveProduct — when the wrapper Name (Overview section) changes,
  // useChangeTracking's getAllChangedProducts() already propagates the new
  // name to every product under this wrapper (see useChangeTracking.ts),
  // in addition to merging in whatever fields the user edited directly on
  // individual products. We rely on that single source of truth here
  // instead of re-deriving the same propagation a second time.
  const handleSaveProduct = async (data: any) => {
    setIsLoadingButton(true);
    try {
      let wrapperUpdateResponse = null;
      let hasError = false;
      if (hasWrapperChanges || hasTimeWeekChanges) {
        const changedWrapperData = getChangedWrapperData();
        const timeWeekData = {
          weekFrom,
          weekTo,
          timeFrom,
          timeTo,
        };
        const allWrapperChanges: Record<string, any> = {
          ...(changedWrapperData || {}),
          ...timeWeekData,
        };
        // ✅ Ensure tags is properly formatted for API
        if (
          allWrapperChanges.tags !== undefined &&
          allWrapperChanges.tags !== null
        ) {
          // If tags is an array, convert to string
          if (Array.isArray(allWrapperChanges.tags)) {
            allWrapperChanges.tags = allWrapperChanges.tags.join(",");
          }
          // If tags is an object with values, convert to string
          else if (typeof allWrapperChanges.tags === "object") {
            const tagValues = Object.values(allWrapperChanges.tags);
            if (tagValues.length > 0) {
              allWrapperChanges.tags = tagValues.join(",");
            } else {
              allWrapperChanges.tags = "";
            }
          }
          // If tags is a number, convert to string
          else if (typeof allWrapperChanges.tags === "number") {
            allWrapperChanges.tags = allWrapperChanges.tags.toString();
          }
        }
        if (Object.keys(allWrapperChanges).length > 0) {
          try {
            const wrapperLogBody = {
              message: "Product Wrapper Settings Updated",
              summary: JSON.stringify([
                `Product wrapper settings updated`,
                `Changes: ${Object.keys(allWrapperChanges)
                  .map((key) => `${key} changed to ${allWrapperChanges[key]}`)
                  .join(", ")}`,
              ]),
              type: "product_wrapper_update",
              code: "update",
              access_type: true,
              metadata: {
                changedBy: "",
                productId: selectedProduct?.[0]?.id || "",
                productName: selectedProduct?.[0]?.name || "",
                changes: allWrapperChanges,
              },
            };
            wrapperUpdateResponse = await saveProductWrapperChanges(
              allWrapperChanges,
              wrapperLogBody,
              "menu",
            );
            console.log("Wrapper update response:", wrapperUpdateResponse);
            setHasTimeWeekChanges(false);
          } catch (err) {
            console.error("Error saving product wrapper:", err);
            hasError = true;
            setError("Failed to update product wrapper settings");
          }
        }
      }
      // ✅ getAllChangedProducts() returns the per-product edits the user
      // made directly, merged with the wrapper-name propagation it applies
      // automatically whenever the wrapper name changed — so calling it
      // unconditionally (not just when hasProductChanges is true) correctly
      // covers the "only renamed the wrapper" case too.
      const combinedProductChanges: Record<string, any> = !hasError
        ? getAllChangedProducts() || {}
        : {};
      const hasAnyProductChanges =
        Object.keys(combinedProductChanges).length > 0;
      if (hasAnyProductChanges && !hasError) {
        try {
          for (const [productId, changes] of Object.entries(
            combinedProductChanges,
          )) {
            const product = selectedProduct.find(
              (p) => p.id?.toString() === productId?.toString(),
            );
            if (product && changes && typeof changes === "object") {
              const productBody = {
                id: product.id,
                locationId: locationId,
                version: product.version,
                ...changes,
              };
              const changesObj = changes as Record<string, any>;
              const productLogBody = {
                message: `Product "${product.name || "Product"}" Updated`,
                summary: JSON.stringify([
                  `Product ID: ${productId}`,
                  `Product Name: ${product.name || "Unknown"}`,
                  `Changes: ${Object.keys(changesObj)
                    .map((key) => `${key}: ${JSON.stringify(changesObj[key])}`)
                    .join(", ")}`,
                ]),
                type: "product_info_update",
                code: "update",
                access_type: true,
                metadata: {
                  changedBy: "",
                  productId: productId,
                  productName: product.name || "",
                  changes: changesObj,
                },
              };
              const response = await updateProductInfo(
                locationId,
                productBody,
                productLogBody,
                "menu",
              );
              if (response?.data?.data) {
                setSelectedProduct((prev) =>
                  prev.map((p) =>
                    p.id?.toString() === productId?.toString()
                      ? { ...p, ...response.data.data }
                      : p,
                  ),
                );
              }
            }
          }
        } catch (err) {
          console.error("Error saving products:", err);
          hasError = true;
          setError("Failed to update product details");
        }
      }
      if (!hasWrapperChanges && !hasTimeWeekChanges && !hasAnyProductChanges) {
        setSuccess("No changes to save");
        setTimeout(() => setSuccess(""), 2000);
        setIsLoadingButton(false);
        return;
      }
      if (hasError) {
        setIsLoadingButton(false);
        return;
      }
      if (wrapperUpdateResponse?.data?.data) {
        const updatedWrapper = wrapperUpdateResponse.data.data;
        setWrapperData(updatedWrapper);
        setIsValidMainProduct(updatedWrapper.valid);
        setIsValidKiosk(updatedWrapper.kiosk?.toString() === "1");
        setColor(updatedWrapper.colour || "");
        setAllYouCanEat(updatedWrapper.allYouCanEat || false);
        setIsValidProductAvailability(updatedWrapper.valid);
        dispatch(
          updateDirectoryInStore({
            id: updatedWrapper.id,
            valid: updatedWrapper.valid,
            version: updatedWrapper.version,
            name: updatedWrapper.name,
            colour: updatedWrapper.colour,
            img: updatedWrapper.img,
            desc: updatedWrapper.desc,
            directory: updatedWrapper.directory,
            directoryId: updatedWrapper.directoryId,
            directoryLevel: updatedWrapper.directoryLevel,
            itemType: updatedWrapper.itemType,
            allYouCanEat: updatedWrapper.allYouCanEat,
            kiosk: updatedWrapper.kiosk,
            cover: updatedWrapper.cover,
            nameShort: updatedWrapper.nameShort,
            viewOrder: updatedWrapper.viewOrder,
          }),
        );
      }
      resetChanges();
      await dispatch(fetchMenuDetails(locationId, menuId));
      setSuccess(SUCCESSFULLY_UPDATED);
      if (onProductUpdated) {
        onProductUpdated();
      }
      setTimeout(() => setSuccess(""), 2000);
    } catch (err) {
      console.error("Error saving product:", err);
      setError(ERROR_MESSAGE_UNEXPECTED_ERROR);
    } finally {
      setIsLoadingButton(false);
    }
  };
  const renderBreadcrumbs = () => {
    const breadcrumbItems = [];
    breadcrumbItems.push(
      <Button
        key="menu"
        size="small"
        onClick={handleNavigateToMenu}
        style={{
          color: theme.palette.custom.orange.contrastText,
          textTransform: "none",
          padding: "4px 8px",
          minWidth: "auto",
        }}
      >
        <HomeIcon style={{ fontSize: "16px", marginRight: "4px" }} />
        {selectedMenuName || "Menu"}
      </Button>,
    );
    if (categoryName) {
      breadcrumbItems.push(
        <Button
          key="category"
          size="small"
          onClick={handleNavigateToCategory}
          style={{
            color:
              directoryStack.length === 0
                ? theme.palette.custom.yellow.main
                : theme.palette.custom.orange.contrastText,
            textTransform: "none",
            padding: "4px 8px",
            minWidth: "auto",
          }}
        >
          {categoryName}
        </Button>,
      );
    }
    directoryStack.forEach((dir, index) => {
      const isLast = index === directoryStack.length - 1;
      breadcrumbItems.push(
        <Button
          key={`dir_${dir.id}`}
          size="small"
          onClick={() => handleNavigateToDirectory(index)}
          style={{
            color: isLast
              ? theme.palette.custom.yellow.main
              : theme.palette.custom.orange.contrastText,
            textTransform: "none",
            padding: "4px 8px",
            minWidth: "auto",
          }}
        >
          {dir.name}
        </Button>,
      );
    });
    breadcrumbItems.push(
      <Button
        key="product"
        size="small"
        style={{
          color: theme.palette.custom.yellow.main,
          textTransform: "none",
          padding: "4px 8px",
          minWidth: "auto",
          cursor: "default",
        }}
      >
        {wrapperData?.name || "Edit Product"}
      </Button>,
    );
    return (
      <Box
        style={{
          padding: "12px 24px",
          backgroundColor: theme.palette.background.default,
        }}
      >
        <Breadcrumbs
          separator={
            <NavigateNextIcon
              fontSize="small"
              style={{ color: theme.palette.custom.orange.contrastText }}
            />
          }
        >
          {breadcrumbItems}
        </Breadcrumbs>
      </Box>
    );
  };
  const handleCopyText = async (text: string) => {
    if (!text) return;
    try {
      await copyToClipboard(text);
      setSuccess("Copied to clipboard!");
      setTimeout(() => setSuccess(""), 2000);
    } catch {
      setError("Failed to copy text.");
    }
  };
  if (isLoading || isRefreshingAfterAdd) {
    return <ProductSkeletonLoading />;
  }
  const handleSubmitData = async () => {
    const entityId = `M${productId}`;
    const existingOptions = menuOptionData?.options || {};
    const updatedOption: any = {
      entityId: entityId,
      isActive: isActive,
      availability: availabilityList.availability || [],
    };
    if (deliveryTypesList.length === allDeliveryTypes.length) {
      updatedOption.deliveryTypes = [];
    } else {
      updatedOption.deliveryTypes = deliveryTypesList;
    }
    if (platformList.length > 0) {
      if (platformList.length === allPlatformIds.length) {
        updatedOption.platform = [];
      } else {
        updatedOption.platform = platformList;
      }
    } else {
      updatedOption.platform = [];
    }
    if (channelList.length > 0) {
      if (channelList.length === allChannelIds.length) {
        updatedOption.orderChannel = [];
      } else {
        updatedOption.orderChannel = channelList;
      }
    } else {
      updatedOption.orderChannel = [];
    }
    const updatedOptions = {
      ...existingOptions,
      [entityId]: updatedOption,
    };
    console.log("updatedOptions", entityId, updatedOptions);
    const requestBody = {
      id: menuOptionData?.id || "",
      title: menuOptionData?.title || "Default Options",
      primaryLocationId: menuOptionData?.primaryLocationId || "",
      created: menuOptionData?.created || new Date().toISOString(),
      updated: new Date().toISOString().replace("T", " ").slice(0, 19),
      version: menuOptionData?.version || 0,
      options: updatedOptions,
    };
    const logBody = {
      message: "Menu Option Information Updated",
      summary: JSON.stringify([
        `Menu option "${menuOptionData?.title || "Default Options"}" updated`,
        `Entity ID: ${entityId}`,
        `Active status: ${isActive ? "Active" : "Inactive"}`,
        `Delivery types: ${
          deliveryTypesList.length === allDeliveryTypes.length
            ? "All"
            : deliveryTypesList.join(", ") || "None"
        }`,
        `Platforms: ${
          platformList.length === allPlatformIds.length
            ? "All"
            : platformList.join(", ") || "None"
        }`,
        `Order channels: ${
          channelList.length === allChannelIds.length
            ? "All"
            : channelList.join(", ") || "None"
        }`,
        `Availability: ${availabilityList.availability?.length || 0} items`,
      ]),
      type: "menu_option_info",
      code: "update",
      access_type: true,
      metadata: {
        changedBy: "",
        entityId: entityId,
        productId: productId,
        menuOptionId: menuOptionData?.id || "",
        changes: {
          isActive: isActive,
          deliveryTypes: deliveryTypesList,
          platform: platformList,
          orderChannel: channelList,
          availabilityCount: availabilityList.availability?.length || 0,
        },
      },
    };
    const updateWithRetry = async (
      body: any,
      maxRetries: number = 3,
    ): Promise<any> => {
      let currentBody = { ...body };
      let attempts = 0;
      while (attempts < maxRetries) {
        try {
          console.log(`Attempt ${attempts + 1}: Sending update request`);
          const response = await updateMenuOptionInfo(
            match.params.locationId,
            menuOptionData.id,
            currentBody,
            logBody,
            "menu",
          );
          console.log("Update successful:", response);
          if (response?.data?.data) {
            setMenuOptionData(response.data.data);
            await getMenuOptionInfo();
            setSuccess("Menu options updated successfully!");
            setTimeout(() => setSuccess(""), 3000);
          }
          return response;
        } catch (error) {
          console.log("Error:", error, menuOptionData);
          const err: any = error as AxiosError;
          if (err?.response?.status === 409 || err?.status === 409) {
            attempts++;
            console.log(
              `Version conflict detected. Attempt ${attempts} of ${maxRetries}`,
            );
            if (attempts < maxRetries) {
              try {
                console.log("Fetching latest data to get new version...");
                const latestRes = await fetchMenuOption(
                  match.params.locationId,
                );
                const latestData = latestRes.data.data;
                setMenuOptionData(latestData);
                const latestOptions = latestData?.options || {};
                const latestEntityOption = latestOptions?.[entityId] || {};
                const mergedOptions = {
                  ...latestOptions,
                  [entityId]: {
                    ...latestEntityOption,
                    isActive: isActive,
                    availability: availabilityList.availability || [],
                    deliveryTypes:
                      deliveryTypesList.length === allDeliveryTypes.length
                        ? []
                        : deliveryTypesList,
                    platform:
                      platformList.length === allPlatformIds.length
                        ? []
                        : platformList,
                    orderChannel:
                      channelList.length === allChannelIds.length
                        ? []
                        : channelList,
                  },
                };
                currentBody = {
                  ...currentBody,
                  version: latestData?.version || 0,
                  options: mergedOptions,
                  updated: new Date()
                    .toISOString()
                    .replace("T", " ")
                    .slice(0, 19),
                };
                console.log(`Retry with new version: ${currentBody.version}`);
              } catch (fetchError) {
                console.error("Error fetching latest data:", fetchError);
                setError(
                  "Failed to fetch latest data. Please refresh and try again.",
                );
                throw fetchError;
              }
            } else {
              setError(
                "Version conflict: Maximum retry attempts reached. Please refresh and try again.",
              );
              throw error;
            }
          } else {
            console.error("Update error:", error);
            setError("Failed to update menu option.");
            throw error;
          }
        }
      }
    };
    try {
      setIsLoadingButton(true);
      await updateWithRetry(requestBody);
      await dispatch(fetchMenuDetails(locationId, menuId));
    } catch (error) {
      console.error("Final error:", error);
    } finally {
      setIsLoadingButton(false);
    }
  };
  return (
    <>
      <Hidden lgUp>
        <PageHeaderMobile />
      </Hidden>
      <Box
        style={{
          padding: "16px 24px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div>{renderBreadcrumbs()}</div>
        <ButtonCommon
          variant="contained"
          onClick={
            isEditDisabled ? handleSubmitData : handleSubmit(handleSaveProduct)
          }
          color="blue"
          style={{
            width: "130px",
            textTransform: "none",
            fontSize: "12px",
          }}
        >
          Save Changes
        </ButtonCommon>
      </Box>
      {isEditDisabled === false && (
        <ProductBanner
          productData={productData}
          productId={productId}
          categoryId={categoryId}
          isValidMainProduct={isValidMainProduct}
          onValidToggle={handleImmediateWrapperValidToggle}
          onCopyText={handleCopyText}
          wrapperData={wrapperData}
          isEditDisabled={isEditDisabled}
        />
      )}
      {isEditDisabled === false && (
        <OverviewSection
          register={register}
          errors={errors}
          open={open}
          setOpen={setOpen}
          itemTypesList={itemTypesList}
          selectedItemType={selectedItemType}
          onItemTypeChange={(e, value) => {
            setSelectedItemType(value);
            trackWrapperChange("itemType", value?.id || value);
          }}
          color={color}
          onColorChange={(newColor) => {
            setColor(newColor);
            trackWrapperChange("colour", newColor);
          }}
          wrapperData={wrapperData}
          productData={productData}
          classes={classes}
          onFieldChange={(field, value, isWrapperField) => {
            if (isWrapperField) {
              trackWrapperChange(field, value);
            } else {
              trackProductChange(field, value, productData?.id);
            }
          }}
        />
      )}
      {isEditDisabled === false && (
        <AvailabilitySection
          isValidProductAvailability={isValidProductAvailability}
          onAvailabilityToggle={handleImmediateAvailabilityToggle}
          allYouCanEat={allYouCanEat}
          onAllYouCanEatToggle={handleImmediateAllYouCanEatToggle}
          isValidKiosk={isValidKiosk}
          onKioskToggle={handleImmediateKioskToggle}
          classes={classes}
          weekFrom={weekFrom}
          setWeekFrom={setWeekFrom}
          weekTo={weekTo}
          setWeekTo={setWeekTo}
          timeFrom={timeFrom}
          setTimeFrom={setTimeFrom}
          timeTo={timeTo}
          setTimeTo={setTimeTo}
          onWeekFromChange={handleWeekFromChange}
          onWeekToChange={handleWeekToChange}
          onTimeFromChange={handleTimeFromChange}
          onTimeToChange={handleTimeToChange}
        />
      )}
      {isEditDisabled === false && (
        <ProductsSection
          selectedProduct={selectedProduct}
          expandedProductIds={expandedProductIds}
          onExpandToggle={toggleProductExpand}
          stockDepartmentSelectedNode={stockDepartmentSelectedNode}
          selectedDepartmentObj={selectedDepartmentObj}
          onDepartmentChange={(dept, productId) => {
            setSelectedDepartmentObj(dept);
            trackProductChange("departmentId", dept?.id, productId);
            setSelectedProduct((prev) =>
              prev.map((p) =>
                p.id === productId ? { ...p, departmentId: dept?.id } : p,
              ),
            );
          }}
          classes={classes}
          calculateMargin={(price, cost) => {
            if (price && cost && price > 0) {
              return (((price - cost) / price) * 100).toFixed(1);
            }
            return "0";
          }}
          onProductFieldChange={(field, value, productId) => {
            trackProductChange(field, value, productId);
            setSelectedProduct((prev) =>
              prev.map((product) => {
                if (product.id === productId) {
                  return { ...product, [field]: value };
                }
                return product;
              }),
            );
          }}
          onImmediateProductValidToggle={handleImmediateProductValidToggle}
          isEditDisabled={isEditDisabled}
          menuId={menuId}
          categoryId={categoryId}
          directoryId={
            directoryStack.length > 0
              ? directoryStack[directoryStack.length - 1]?.id
              : undefined
          }
          directoryLevel={directoryStack.length + 1}
          isRoot={directoryStack.length === 0}
          firstWrapperId={wrapperData?.id}
          wrapperId={wrapperData?.id}
          onProductAdded={async (newProduct) => {
            console.log("Product added:", newProduct);
            // ✅ Show the loading skeleton immediately (modal is already
            // closed by ProductsSection at this point) instead of waiting
            // for fetchMenuDetails/refreshProductData to finish first.
            setIsRefreshingAfterAdd(true);
            try {
              // ✅ Refresh menu details from API
              await dispatch(fetchMenuDetails(locationId, menuId));
              setIsProductAddModalOpen(false);
              setSuccess(SUCCESSFULLY_CREATED);
              // ✅ Refresh product data from hook - this will update selectedProduct
              await refreshProductData();

              // ✅ Directly update selectedProduct state with new product
              if (newProduct) {
                const newWrapper = newProduct.itemWrapperId || newProduct;
                // ✅ Check if newWrapper has valid data
                if (
                  newWrapper &&
                  newWrapper.id &&
                  newWrapper.name &&
                  newWrapper.name.trim() !== ""
                ) {
                  setSelectedProduct((prev) => {
                    // ✅ Filter out any empty products (without name)
                    const filteredPrev = prev.filter(
                      (p) => p && p.name && p.name.trim() !== "",
                    );
                    // Check if product already exists
                    const exists = filteredPrev.some(
                      (p) => p.id === newWrapper.id,
                    );
                    if (exists) {
                      return filteredPrev.map((p) =>
                        p.id === newWrapper.id ? { ...p, ...newWrapper } : p,
                      );
                    }
                    // ✅ Add new product to the list
                    return [...filteredPrev, newWrapper];
                  });
                }
              }
              if (onProductUpdated) {
                onProductUpdated();
              }
            } finally {
              setIsRefreshingAfterAdd(false);
            }
          }}
          isProductAddModalOpen={isProductAddModalOpen}
          setIsProductAddModalOpen={setIsProductAddModalOpen}
          wrapperData={wrapperData}
        />
      )}
      {isEditDisabled === false && (
        <TagsSpotlightSection
          currentMenuData={currentMenuData}
          availableTags={availableTags}
          selectedTags={selectedTags}
          onTagsChange={(tags) => {
            console.log("asdfas3fsdgdfg", tags);
            setSelectedTags(tags);
            const tagsString = tags.map((t: any) => t.id).join(",");
            trackWrapperChange("tags", tagsString);
          }}
          spotlightText={spotlightText}
          onSpotlightTextChange={(text) => {
            setSpotlightText(text);
            trackWrapperChange("spotlight", text);
          }}
          classes={classes}
          wrapperData={wrapperData}
        />
      )}
      {isEditDisabled === false && (
        <SystemInformationSection
          productData={productData}
          wrapperData={wrapperData}
        />
      )}
      {isEditDisabled === false && (
        <ActionButtons
          onCancel={handleBackToDirectory}
          onSave={handleSubmit(handleSaveProduct)}
          isLoading={isLoadingButton}
          isEditDisabled={isEditDisabled}
        />
      )}
      {isEditDisabled && (
        <AvailabilitySections
          menuOptionNodeObj={menuOptionNodeObj}
          menuOptionData={menuOptionData}
          isActive={isActive}
          setIsActive={setIsActive}
          deliveryTypesList={deliveryTypesList}
          setDeliveryTypesList={setDeliveryTypesList}
          platformList={platformList}
          setPlatformList={setPlatformList}
          channelList={channelList}
          setChannelList={setChannelList}
          availabilityList={availabilityList}
          setAvailabilityList={setAvailabilityList}
          isActiveInitial={isActiveInitial}
          setIsActiveInitial={setIsActiveInitial}
          deliveryTypesListInitial={deliveryTypesListInitial}
          setDeliveryTypesListInitial={setDeliveryTypesListInitial}
          platformListInitial={platformListInitial}
          setPlatformListInitial={setPlatformListInitial}
          channelListInitial={channelListInitial}
          setChannelListInitial={setChannelListInitial}
          availabilityListInitial={availabilityListInitial}
          setAvailabilityListInitial={setAvailabilityListInitial}
          originalNodeData={originalNodeData}
          setOriginalNodeData={setOriginalNodeData}
        />
      )}
      <DefaultAlert
        open={!!error}
        handleClose={() => setError("")}
        message={error}
        severity="error"
      />
      <DefaultAlert
        open={!!success}
        handleClose={() => setSuccess("")}
        message={success}
        severity="success"
      />
      {/* ✅ Confirmation Dialog for unsaved changes */}
      <Dialog
        open={isLeaveDialogOpen}
        onClose={handleCancelLeave}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          style: {
            backgroundColor: theme.palette.background.default,
            borderRadius: "16px",
            padding: "16px",
          },
        }}
      >
        <DialogTitle>
          <Typography variant="h6" style={{ fontWeight: "bold" }}>
            Unsaved Changes
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography
            variant="body2"
            style={{ color: theme.palette.text.secondary }}
          >
            You have unsaved changes. Are you sure you want to leave? Your
            changes will be lost.
          </Typography>
        </DialogContent>
        <DialogActions style={{ padding: "16px 24px", gap: "12px" }}>
          <ButtonCommon
            variant="contained"
            style={{ fontSize: 11, width: "100px" }}
            color="yellow"
            onClick={handleCancelLeave}
          >
            Stay
          </ButtonCommon>
          <ButtonCommon
            variant="contained"
            style={{ fontSize: 11, width: "100px" }}
            color="red"
            onClick={handleConfirmLeave}
          >
            Leave
          </ButtonCommon>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default withAuthority(MenuProduct, Authorities.MENU_READ);
